<div class="wrapper">
    <div class="login-wrapper pd-t70 pd-b35 d-flex">
        <div class="login-wrapper__inner">
            <!-- left panel with image and content -->
            <section class="left-panel">
                <div class="left-panel--top">
                    <img src="assets/images/upgradRed/upgradEntLoginLogo.png" alt="Logo" />
                    <p>The Learning Institute of choice For Professionals </p>
                </div>
                <div class="left-panel--image">
                    <img src="assets/images/upgradRed/upgradLoginPeopleLogo.png" alt="" />
                </div>
            </section>
            <!-- left panel with only image --->
            <section class="right-panel">
                <div class="right-panel__logo">
                    <!-- <img src="assets/images/logo_icon.png" alt="Harappa Logo" /> -->
                    <h2>CREATE YOUR <span>password</span></h2>
                </div>
                <div class="right-panel__form">
                    <form [formGroup]="createPassForm" (ngSubmit)="onSubmitPass()" >
                        <div class="right-panel__form--group">
                          <label for="input">Password <span class="text-danger">*</span> </label>
                            <input formControlName="newPassword"
                                   type="{{!passwordText ? 'password' : 'text'}}"
                                   required="required"
                                   value=""
                                   id="password-field"
                                   minlength="8"
                                   [ngClass]="{'has-value': createPassForm.get('newPassword')?.dirty}">
                                <i class="bar"></i>
                                <div *ngIf="createPassForm.get('newPassword')?.errors?.required && (createPassForm.get('newPassword')?.dirty || createPassForm.get('newPassword')?.touched)">
                                <span class="errror--class">Password is required</span>
                            </div>
                            <div *ngIf="createPassForm.get('newPassword')?.errors?.minlength ">
                                <span class="errror--class">Password must be at least 8 characters.</span>
                            </div>
                        </div>
                        <div class="right-panel__form--group has-error">
                          <label for="input"> Confirm Password <span class="text-danger"> * </span></label>
                            <input [ngClass]="{'has-value': createPassForm.get('confirmNewPassword')?.dirty}"
                                    formControlName="confirmNewPassword"
                                    type="{{!passwordText ? 'password' : 'text'}}" required="required" value="" id="password-field"
                                    minlength="8" /><i class="bar"></i>
                            <div *ngIf="createPassForm.get('confirmNewPassword')?.errors?.required && (createPassForm.get('confirmNewPassword')?.dirty || createPassForm.get('confirmNewPassword')?.touched)">
                                <span class="errror--class">Password is required</span>
                            </div>
                            <div *ngIf="createPassForm.get('confirmNewPassword')?.errors?.minlength ">
                                <span class="errror--class">Password must be at least 8 characters.</span>
                            </div>

                            <!-- <div *ngIf="createPassForm.get('confirmNewPassword')?.errors?.required && (createPassForm.get('confirmNewPassword').dirty || createPassForm.get('confirmNewPassword').touched)" class="input-error">Password is required</div> -->
                            <div *ngIf="createPassForm.get('confirmNewPassword')?.errors?.mustMatch"  class="errror--class">The passwords you typed do not match. Try again.</div>
                            <!-- <span class="errror--class">Password doesn't matched.</span> -->
                            <!-- <span class="confirm--class d-none">Password matched.</span> -->
                        </div>
                        <div class="d-flex align-items-start button-container">
                            <button [disabled]="!createPassForm.valid" type="button" class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20" type="submit"><span>Submit</span></button>
                            <!-- <a href="https://programs.harappa.education/hc/en-us" class="btn-link">Need help?</a> -->
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</div>
